exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-header {\n  font-size: 10px;\n}\n", ""]);

// exports
